<script setup lang="ts">
import { ref } from 'vue';
import { computedAsync } from '@vueuse/core';
import useClaimStore from "@/store/ClaimStore";
import adminAPI from "@/services/api";

import PassengerTable from "@/components/passengers/PassengerTable.vue";
import BaseButton from '@/components/ui/buttons/BaseButton.vue';

const claimId = useClaimStore().claim.id

const showPnr = ref(false);
const data =  computedAsync(() => adminAPI.retrieveClaimHistory(claimId));
</script>
<template>
  <PassengerTable />
  <div class="mt-4 text-left" v-permission="['UPCLAIM_ADMIN']">
    <div class="flex justify-center py-4">
      <BaseButton :text="!showPnr ? 'Afficher le PNR' : 'Masquer le PNR'" @click="showPnr = !showPnr" size="lg" />
    </div>
    <json-viewer v-if="showPnr" class=" min-h-max" :expand-depth=10 copyable :value="data"></json-viewer>
  </div>
</template>